export const timeZones = [
    {
        label: '(UTC-12:00) International Date Line West',
        id: 'Etc/GMT+12'
    },
    {
        label: '(UTC-11:00) Coordinated Universal Time-11',
        id: 'Etc/GMT+11'
    },
    {
        label: '(UTC-10:00) Hawaii',
        id: 'Etc/GMT+10'
    },
    {
        label: '(UTC-09:00) Alaska',
        id: 'America/Anchorage'
    },
    {
        label: '(UTC-08:00) Baja California',
        id: 'America/Santa_Isabel'
    },
    {
        label: '(UTC-07:00) Pacific Daylight Time (US & Canada)',
        id: 'America/Los_Angeles'
    },
    {
        label: '(UTC-07:00) Arizona',
        id: 'America/Creston'
    },
    {
        label: '(UTC-07:00) Chihuahua, La Paz, Mazatlan',
        id: 'America/Chihuahua'
    },
    {
        label: '(UTC-07:00) Mountain Time (US & Canada)',
        id: 'America/Boise'
    },
    {
        label: '(UTC-06:00) Central America',
        id: 'America/Belize'
    },
    {
        label: '(UTC-06:00) Central Time (US & Canada)',
        id: 'America/Chicago'
    },
    {
        label: '(UTC-06:00) Guadalajara, Mexico City, Monterrey',
        id: 'America/Bahia_Banderas'
    },
    {
        label: '(UTC-06:00) Saskatchewan',
        id: 'America/Regina'
    },
    {
        label: '(UTC-05:00) Bogota, Lima, Quito',
        id: 'America/Bogota'
    },
    {
        label: '(UTC-05:00) Eastern Time (US & Canada)',
        id: 'America/Detroit'
    },
    {
        label: '(UTC-05:00) Indiana (East)',
        id: 'America/Indiana/Marengo'
    },
    {
        label: '(UTC-04:30) Caracas',
        id: 'America/Caracas'
    },
    {
        label: '(UTC-04:00) Asuncion',
        id: 'America/Asuncion'
    },
    {
        label: '(UTC-04:00) Atlantic Time (Canada)',
        id: 'America/Glace_Bay'
    },
    {
        label: '(UTC-04:00) Cuiaba',
        id: 'America/Campo_Grande'
    },
    {
        label: '(UTC-04:00) Georgetown, La Paz, Manaus, San Juan',
        id: 'America/Anguilla'
    },
    {
        label: '(UTC-04:00) Santiago',
        id: 'America/Santiago'
    },
    {
        label: '(UTC-03:30) Newfoundland',
        id: 'America/St_Johns'
    },
    {
        label: '(UTC-03:00) Brasilia',
        id: 'America/Sao_Paulo'
    },
    {
        label: '(UTC-03:00) Buenos Aires',
        id: 'America/Argentina/Buenos_Aires'
    },
    {
        label: '(UTC-03:00) Cayenne, Fortaleza',
        id: 'America/Araguaina'
    },
    {
        label: '(UTC-03:00) Greenland',
        id: 'America/Godthab'
    },
    {
        label: '(UTC-03:00) Montevideo',
        id: 'America/Montevideo'
    },
    {
        label: '(UTC-03:00) Salvador',
        id: 'America/Bahia'
    },
    {
        label: '(UTC-02:00) Coordinated Universal Time-02',
        id: 'America/Noronha'
    },
    {
        label: '(UTC-01:00) Azores',
        id: 'America/Scoresbysund'
    },
    {
        label: '(UTC-01:00) Cape Verde Is.',
        id: 'Atlantic/Cape_Verde'
    },
    {
        label: '(UTC) Casablanca',
        id: 'Africa/Casablanca'
    },
    {
        label: '(UTC) Coordinated Universal Time',
        id: 'America/Danmarkshavn'
    },
    {
        label: '(UTC) Edinburgh, London',
        id: 'Europe/Isle_of_Man'
    },
    {
        label: '(UTC+01:00) Edinburgh, London',
        id: 'Europe/Isle_of_Man'
    },
    {
        label: '(UTC) Dublin, Lisbon',
        id: 'Atlantic/Canary'
    },
    {
        label: '(UTC) Monrovia, Reykjavik',
        id: 'Africa/Abidjan'
    },
    {
        label: '(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
        id: 'Arctic/Longyearbyen'
    },
    {
        label: '(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague',
        id: 'Europe/Belgrade'
    },
    {
        label: '(UTC+01:00) Brussels, Copenhagen, Madrid, Paris',
        id: 'Africa/Ceuta'
    },
    {
        label: '(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb',
        id: 'Europe/Sarajevo'
    },
    {
        label: '(UTC+01:00) West Central Africa',
        id: 'Africa/Algiers'
    },
    {
        label: '(UTC+01:00) Windhoek',
        id: 'Africa/Windhoek'
    },
    {
        label: '(UTC+02:00) Athens, Bucharest',
        id: 'Asia/Nicosia'
    },
    {
        label: '(UTC+02:00) Beirut',
        id: 'Asia/Beirut'
    },
    {
        label: '(UTC+02:00) Cairo',
        id: 'Africa/Cairo'
    },
    {
        label: '(UTC+02:00) Damascus',
        id: 'Asia/Damascus'
    },
    {
        label: '(UTC+02:00) Harare, Pretoria',
        id: 'Africa/Blantyre'
    },
    {
        label: '(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
        id: 'Europe/Helsinki'
    },
    {
        label: '(UTC+03:00) Istanbul',
        id: 'Europe/Istanbul'
    },
    {
        label: '(UTC+02:00) Jerusalem',
        id: 'Asia/Jerusalem'
    },
    {
        label: '(UTC+02:00) Tripoli',
        id: 'Africa/Tripoli'
    },
    {
        label: '(UTC+03:00) Amman',
        id: 'Asia/Amman'
    },
    {
        label: '(UTC+03:00) Baghdad',
        id: 'Asia/Baghdad'
    },
    {
        label: '(UTC+02:00) Kaliningrad',
        id: 'Europe/Kaliningrad'
    },
    {
        label: '(UTC+03:00) Kuwait, Riyadh',
        id: 'Asia/Aden'
    },
    {
        label: '(UTC+03:00) Nairobi',
        id: 'Africa/Addis_Ababa'
    },
    {
        label: '(UTC+03:00) Moscow, St. Petersburg, Volgograd, Minsk',
        id: 'Europe/Kirov'
    },
    {
        label: '(UTC+04:00) Samara, Ulyanovsk, Saratov',
        id: 'Europe/Astrakhan'
    },
    {
        label: '(UTC+03:30) Tehran',
        id: 'Asia/Tehran'
    },
    {
        label: '(UTC+04:00) Abu Dhabi, Muscat',
        id: 'Asia/Dubai'
    },
    {
        label: '(UTC+04:00) Baku',
        id: 'Asia/Baku'
    },
    {
        label: '(UTC+04:00) Port Louis',
        id: 'Indian/Mahe'
    },
    {
        label: '(UTC+04:00) Tbilisi',
        id: 'Asia/Tbilisi'
    },
    {
        label: '(UTC+04:00) Yerevan',
        id: 'Asia/Yerevan'
    },
    {
        label: '(UTC+04:30) Kabul',
        id: 'Asia/Kabul'
    },
    {
        label: '(UTC+05:00) Ashgabat, Tashkent',
        id: 'Antarctica/Mawson'
    },
    {
        label: '(UTC+05:00) Yekaterinburg',
        id: 'Asia/Yekaterinburg'
    },
    {
        label: '(UTC+05:00) Islamabad, Karachi',
        id: 'Asia/Karachi'
    },
    {
        label: '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi',
        id: 'Asia/Kolkata'
    },
    {
        label: '(UTC+05:30) Sri Jayawardenepura',
        id: 'Asia/Colombo'
    },
    {
        label: '(UTC+05:45) Kathmandu',
        id: 'Asia/Kathmandu'
    },
    {
        label: '(UTC+06:00) Nur-Sultan (Astana)',
        id: 'Antarctica/Vostok'
    },
    {
        label: '(UTC+06:00) Dhaka',
        id: 'Asia/Dhaka'
    },
    {
        label: '(UTC+06:30) Yangon (Rangoon)',
        id: 'Asia/Rangoon'
    },
    {
        label: '(UTC+07:00) Bangkok, Hanoi, Jakarta',
        id: 'Antarctica/Davis'
    },
    {
        label: '(UTC+07:00) Novosibirsk',
        id: 'Asia/Novokuznetsk'
    },
    {
        label: '(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi',
        id: 'Asia/Hong_Kong'
    },
    {
        label: '(UTC+08:00) Krasnoyarsk',
        id: 'Asia/Krasnoyarsk'
    },
    {
        label: '(UTC+08:00) Kuala Lumpur, Singapore',
        id: 'Asia/Brunei'
    },
    {
        label: '(UTC+08:00) Perth',
        id: 'Antarctica/Casey'
    },
    {
        label: '(UTC+08:00) Taipei',
        id: 'Asia/Taipei'
    },
    {
        label: '(UTC+08:00) Ulaanbaatar',
        id: 'Asia/Choibalsan'
    },
    {
        label: '(UTC+08:00) Irkutsk',
        id: 'Asia/Irkutsk'
    },
    {
        label: '(UTC+09:00) Osaka, Sapporo, Tokyo',
        id: 'Asia/Dili'
    },
    {
        label: '(UTC+09:00) Seoul',
        id: 'Asia/Pyongyang'
    },
    {
        label: '(UTC+09:30) Adelaide',
        id: 'Australia/Adelaide'
    },
    {
        label: '(UTC+09:30) Darwin',
        id: 'Australia/Darwin'
    },
    {
        label: '(UTC+10:00) Brisbane',
        id: 'Australia/Brisbane'
    },
    {
        label: '(UTC+10:00) Canberra, Melbourne, Sydney',
        id: 'Australia/Melbourne'
    },
    {
        label: '(UTC+10:00) Guam, Port Moresby',
        id: 'Antarctica/DumontDUrville'
    },
    {
        label: '(UTC+10:00) Hobart',
        id: 'Australia/Currie'
    },
    {
        label: '(UTC+09:00) Yakutsk',
        id: 'Asia/Chita'
    },
    {
        label: '(UTC+11:00) Solomon Is., New Caledonia',
        id: 'Antarctica/Macquarie'
    },
    {
        label: '(UTC+11:00) Vladivostok',
        id: 'Asia/Sakhalin'
    },
    {
        label: '(UTC+12:00) Auckland, Wellington',
        id: 'Antarctica/McMurdo'
    },
    {
        label: '(UTC+12:00) Coordinated Universal Time+12',
        id: 'Etc/GMT-12'
    },
    {
        label: '(UTC+12:00) Fiji',
        id: 'Pacific/Fiji'
    },
    {
        label: '(UTC+12:00) Magadan',
        id: 'Asia/Anadyr'
    },
    {
        label: '(UTC+12:00) Petropavlovsk-Kamchatsky - Old',
        id: 'Asia/Kamchatka'
    },
    {
        label: '(UTC+13:00) Nukualofa',
        id: 'Etc/GMT-13'
    },
    {
        label: '(UTC+13:00) Samoa',
        id: 'Pacific/Apia'
    }
];
